import { render } from "./companyIndex.vue?vue&type=template&id=36a04466"
import script from "./companyIndex.vue?vue&type=script&lang=js"
export * from "./companyIndex.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__